// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HorizontalTabs_wrapper__tQa0S","header":"HorizontalTabs_header__3W9at","active":"HorizontalTabs_active__1CIyd","tab":"HorizontalTabs_tab__wJTLg"};